import { useTranslation } from 'react-i18next';
import { ArrowLeft } from 'lucide-react';
import { cn } from '@/lib/utils';

// "‹ All services" plus a 3-part bar: 1. Time · 2. Details · 3. Done.
// active is 0, 1 or 2. The back link is hidden once the booking is made.
export function StepProgress({ active, onBack }: { active: number; onBack?: () => void }) {
  const { t } = useTranslation('bookingPage');
  const labels = [t('steps.progress.time'), t('steps.progress.details'), t('steps.progress.done')];

  return (
    <div className="flex flex-col gap-1.5 sm:gap-2" data-testid="step-progress" data-active={active}>
      {onBack && (
        <button
          type="button"
          onClick={onBack}
          className="inline-flex min-h-[44px] items-center gap-1.5 self-start text-[14px] font-medium text-soft hover:text-ink"
        >
          <ArrowLeft className="h-4 w-4" />
          {t('steps.allServices')}
        </button>
      )}
      <ol className="flex gap-2" aria-label={t('steps.progress.label')}>
        {labels.map((label, i) => (
          <li key={label} className="flex flex-1 flex-col gap-1.5" aria-current={i === active ? 'step' : undefined}>
            <span className={cn('h-1 rounded-pill', i <= active ? 'bg-brand-500' : 'bg-line')} />
            <span className={cn('text-[13px]', i === active ? 'font-semibold text-ink' : 'font-medium text-soft')}>
              {i + 1}. {label}
            </span>
          </li>
        ))}
      </ol>
    </div>
  );
}
